import React from 'react';

const WelcomeSection = ({ studentName, currentLevel, progressPercentage }) => {
  const getGreeting = () => {
    const hour = new Date()?.getHours();
    if (hour < 12) return "Bonjour";
    if (hour < 18) return "Bon après-midi";
    return "Bonsoir";
  };

  return (
    <div className="bg-gradient-to-br from-primary to-secondary rounded-xl p-6 md:p-8 lg:p-10 text-white shadow-lg">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
        <div className="flex-1">
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-semibold mb-2">
            {getGreeting()}, {studentName} !
          </h1>
          <p className="text-base md:text-lg lg:text-xl opacity-90 mb-4">
            {currentLevel}
          </p>
          <p className="text-sm md:text-base opacity-80">
            Continuez votre parcours d'orientation et découvrez les filières qui vous correspondent le mieux.
          </p>
        </div>
        
        <div className="flex items-center justify-center lg:justify-end">
          <div className="relative w-32 h-32 md:w-40 md:h-40 lg:w-48 lg:h-48">
            <svg className="transform -rotate-90 w-full h-full">
              <circle
                cx="50%"
                cy="50%"
                r="45%"
                stroke="rgba(255, 255, 255, 0.2)"
                strokeWidth="8"
                fill="none"
              />
              <circle
                cx="50%"
                cy="50%"
                r="45%"
                stroke="white"
                strokeWidth="8"
                fill="none"
                strokeDasharray={`${2 * Math.PI * 45} ${2 * Math.PI * 45}`}
                strokeDashoffset={2 * Math.PI * 45 * (1 - progressPercentage / 100)}
                strokeLinecap="round"
                className="transition-all duration-1000 ease-out"
              />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <span className="text-3xl md:text-4xl lg:text-5xl font-bold">{progressPercentage}%</span>
              <span className="text-xs md:text-sm opacity-90">Progression</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeSection;